// MasterDataManager.jsx

import React, { useState } from "react";
import NewIngredient from "./NewIngredient"
import RM_DB from "./RM_DB";

export default function MasterDataManager() {
  const [activeTab, setActiveTab] = useState("ingredients");

  return (
    <div className="w-full font-sans mb-5">
      <div className="bg-white border border-gray-200 rounded-2xl shadow-sm overflow-hidden">

        {/* ───────────────── HEADER ───────────────── */}
        <div className="flex items-center justify-between px-6 py-5 border-b border-gray-100 bg-gradient-to-r from-gray-50 to-white">
          <div>
            <h2 className="text-2xl font-bold text-gray-900">
              Ingredient & RM Database
            </h2>

            <p className="text-sm text-gray-500 mt-1">
              Unified ingredient and raw material management section
            </p>
          </div>
        </div>

        {/* ───────────────── TABS ───────────────── */}
        <div className="flex items-center gap-2 px-6 pt-5">

          {/* Ingredient Tab */}
          <button
            onClick={() => setActiveTab("ingredients")}
            className={`px-5 py-2.5 rounded-xl text-sm font-semibold transition
              ${
                activeTab === "ingredients"
                  ? "bg-black text-white"
                  : "bg-gray-100 text-gray-700 hover:bg-gray-200"
              }`}
          >
            Ingredients
          </button>

          {/* RM Tab */}
          <button
            onClick={() => setActiveTab("rm")}
            className={`px-5 py-2.5 rounded-xl text-sm font-semibold transition
              ${
                activeTab === "rm"
                  ? "bg-black text-white"
                  : "bg-gray-100 text-gray-700 hover:bg-gray-200"
              }`}
          >
            RM Database
          </button>
        </div>

        {/* ───────────────── CONTENT ───────────────── */}
        <div className="p-6">

          {/* INGREDIENT SECTION */}
          {activeTab === "ingredients" && (
            <div className="animate-fadeIn">
              <NewIngredient/>
            </div>
          )}

          {/* RM SECTION */}
          {activeTab === "rm" && (
            <div className="animate-fadeIn">
              <RM_DB />
            </div>
          )}

        </div>
      </div>
    </div>
  );
}